import React from 'react'
import PropTypes from 'prop-types'
import { useLocation } from 'react-router-dom'
import { useTranslation } from 'react-i18next'
import { HeaderGradient } from 'components'
import {
  Section,
  SectionHeader,
  SectionTitle,
  SeeAllLink,
  Cells
} from '../Search.styles'

const MAX_CATEGORY_PREVIEW_ITEMS = 4

function CategorySection({ title, categoryKey, items, searched, renderItem }) {
  const { t } = useTranslation()
  const location = useLocation()
  const searchBackTo = `${location.pathname}${location.search}${location.hash}`
  const cells = items
    .slice(0, MAX_CATEGORY_PREVIEW_ITEMS)
    .map((item, index) => renderItem(item, index))

  return (
    <Section>
      <SectionHeader>
        <SectionTitle>{title}</SectionTitle>
        {items.length !== 0 && (
          <SeeAllLink
            state={{ searchBackTo }}
            to={`/search/${categoryKey}?q=${searched}`}
          >
            {t('search.see-all')}
          </SeeAllLink>
        )}
        <HeaderGradient isFullWidth noMargins />
      </SectionHeader>
      <Cells>{cells}</Cells>
    </Section>
  )
}

CategorySection.propTypes = {
  title: PropTypes.node.isRequired,
  categoryKey: PropTypes.string.isRequired,
  items: PropTypes.arrayOf(PropTypes.object).isRequired,
  searched: PropTypes.string,
  renderItem: PropTypes.func.isRequired
}

export default CategorySection
